/**
 * View component for /scenes/:sceneId
 *
 * Displays a single scene from the 'byId' map in the scene reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import renderHTML from 'react-render-html';

// import actions
import * as sceneActions from '../sceneActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import richContentUtils from '../../../global/utils/richContentUtils';

import ResourceLinkListItem from '../../resourceLink/components/ResourceLinkListItem.js.jsx';

// import scene css modules
import sceneStyles from '../sceneModuleStyles.css';


class SceneContent extends Base {
  constructor(props) {
    super(props);
    this.state = {
      viewing: 'resources'
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.scene && nextProps.scene.chart && nextProps.scene.chart.blocks && nextProps.scene.chart.blocks.length > 0) {
      this.setState({viewing: 'chart'})
    } else {
      this.setState({viewing: 'resources'})
    }
  }

  render() {
    const {
      courseResourceLinks
      , scene
      , sceneResourceLinks
      , studyResourceLinks
      , tmName
      , tmResourceLinks
    } = this.props;
    const { viewing } = this.state;
    const noCourseLinks = (
      !courseResourceLinks
      || (courseResourceLinks && courseResourceLinks.length < 1)
    )
    // courseResourceLinks.map((item, i)=> console.log(item))
    // console.log(courseResourceLinks)
    const noStudyLinks = (
      !studyResourceLinks
      || (studyResourceLinks && studyResourceLinks.length < 1)
    )
    const noSceneLinks = (
      !sceneResourceLinks
      || (sceneResourceLinks && sceneResourceLinks.length < 1)
    )
    // console.log('sceneResourceLinks')
    // console.log(sceneResourceLinks)
    const noCMLinks = (
      !tmResourceLinks
      || (tmResourceLinks && tmResourceLinks.length < 1)
    )

    const hasResourceLinks = (
      !noCourseLinks
      || !noStudyLinks
      || !noSceneLinks
      || !noCMLinks
    )

    let descriptionHTML = null;
    if(scene && scene.description && scene.description.blocks && scene.description.blocks.length > 0) {
      descriptionHTML = richContentUtils.editorState(scene.description);
    }
    let chartHTML = null;
    if(scene && scene.chart && scene.chart.blocks && scene.chart.blocks.length > 0) {
      chartHTML = richContentUtils.editorState(scene.chart);
    }
    let transcriptHTML = null;
    if(scene && scene.transcript && scene.transcript.blocks && scene.transcript.blocks.length > 0) {
      transcriptHTML = richContentUtils.editorState(scene.transcript);
    }
    let chartLink = classNames('-link', {'-active': this.state.viewing === 'chart'});
    let descriptionLink = classNames('-link', {'-active': this.state.viewing === 'description'});
    let resourcesLink = classNames('-link', {'-active': this.state.viewing === 'resources'});
    let transcriptLink = classNames('-link', {'-active': this.state.viewing === 'transcript'});
    return (
      <div className="scene-content">
        <small><em>{tmName}</em></small>
        <h2 className="scene-title">{scene.title}</h2>
        <div className="-viewing-links">
          { chartHTML ?
            <div className={chartLink} onClick={() => this.setState({viewing: 'chart'})}>Chart</div>
            :
            null
          }
          { hasResourceLinks ?
            <div className={resourcesLink} onClick={() => this.setState({ viewing: 'resources' })}>Resources</div>
            :
            null
          }
          { descriptionHTML ?
            <div className={descriptionLink} onClick={() => this.setState({viewing: 'description'})}>Scene details</div>
            :
            null
          }
          { transcriptHTML ?
            <div className={transcriptLink} onClick={() => this.setState({viewing: 'transcript'})}>Transcript</div>
            :
            null
          }
        </div>

        { viewing === 'resources' ?
          <div>
            { noSceneLinks ?
              null
              :
              <div>
                <strong>Resource links for this scene:</strong>
                <div className="resource-links">
                  {sceneResourceLinks.map((rLink, i) =>
                    <ResourceLinkListItem
                      dispatch={this.props.dispatch}
                      key={rLink._id + i}
                      resourceLink={rLink}
                    />
                  )}
                </div>
              </div>
            }
            { noCMLinks ?
              null
              :
              <div>
                <strong>Module resource links:</strong>
                <div className="resource-links">
                  {tmResourceLinks.map((rLink, i) =>
                    <ResourceLinkListItem
                      dispatch={this.props.dispatch}
                      key={rLink._id + i}
                      resourceLink={rLink}
                    />
                  )}
                </div>
              </div>
            }
            { noCourseLinks ?
              null
              :
              <div>
                <strong>Course resource links:</strong>
                <div className="resource-links">
                  {courseResourceLinks.map((rLink, i) =>
                    <ResourceLinkListItem
                      dispatch={this.props.dispatch}
                      key={rLink._id + i}
                      resourceLink={rLink}
                    />
                  )}
                </div>
              </div>
            }
            { noStudyLinks ?
              null
              :
              <div>
                <strong>Study resource links:</strong>
                <div className="resource-links">
                  {studyResourceLinks.map((rLink, i) =>
                    <ResourceLinkListItem
                      dispatch={this.props.dispatch}
                      key={rLink._id + i}
                      resourceLink={rLink}
                    />
                  )}
                </div>
              </div>
            }
          </div>
          : viewing === 'chart' ?
            renderHTML(chartHTML)
          : viewing === 'transcript' ?
            renderHTML(transcriptHTML)
          : viewing === 'description' ?
            <div>
              { descriptionHTML ?
                renderHTML(descriptionHTML)
                :
                <div>{scene.summary}</div>
              }
            </div>
          :
          null
        }
      </div>
    )
  }
}

SceneContent.propTypes = {
  courseResourceLinks: PropTypes.array
  , scene: PropTypes.object.isRequired
  , sceneResourceLinks: PropTypes.array
  , studyResourceLinks: PropTypes.array
  , tmName: PropTypes.string.isRequired
  , tmResourceLinks: PropTypes.array
}

SceneContent.defaultProps = {
  courseResourceLinks: []
  , sceneResourceLinks: []
  , studyResourceLinks: []
  , tmResourceLinks: []
}

export default withRouter(SceneContent);



// WEBPACK FOOTER //
// modules/scene/components/SceneContent.js.jsx